import { ChangeEvent } from "react";
import Grid from "@mui/material/Grid";
import InputAdornment from "@mui/material/InputAdornment";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import { InactiveStoreBranchResponse } from "../../types/inactive-stores.type";
import FilterField from "../SaleDepositReport/FilterField";
import {
  ALL_BRANCHES_LABEL,
  ALL_OPTION,
  StoreFilterValues,
  branchOptionLabel,
} from "./inactiveStores";

type FieldChangeEvent = ChangeEvent<HTMLInputElement | HTMLTextAreaElement>;

const SEARCH_INPUT_PROPS = {
  input: {
    startAdornment: (
      <InputAdornment position="start">
        <SearchIcon fontSize="small" />
      </InputAdornment>
    ),
  },
};

interface StoreFiltersProps {
  branches: InactiveStoreBranchResponse[];
  vanOptions: string[];
  groupOptions: string[];
  filters: StoreFilterValues;
  onChange: (filters: StoreFilterValues) => void;
}

/** Filters for the detail table and its export only; the pivot above never follows them. */
export default function StoreFilters({
  branches,
  vanOptions,
  groupOptions,
  filters,
  onChange,
}: Readonly<StoreFiltersProps>) {
  // A branch reader's summary holds only their own branch, so there is nothing to choose.
  const showsBranchFilter = branches.length > 1;

  const handleBranchChange = (event: FieldChangeEvent) =>
    onChange({ ...filters, branchCode: event.target.value });

  const handleVanChange = (event: FieldChangeEvent) =>
    onChange({ ...filters, van: event.target.value });

  const handleGroupChange = (event: FieldChangeEvent) =>
    onChange({ ...filters, shopGroup: event.target.value });

  const handleSearchChange = (event: FieldChangeEvent) =>
    onChange({ ...filters, search: event.target.value });

  return (
    <Grid container spacing={2} mb={2} alignItems="center">
      {showsBranchFilter && (
        <FilterField label="สาขา">
          <TextField
            select
            size="small"
            fullWidth
            value={filters.branchCode}
            onChange={handleBranchChange}
          >
            <MenuItem value={ALL_OPTION}>{ALL_BRANCHES_LABEL}</MenuItem>
            {branches.map((branch) => (
              <MenuItem key={branch.branch_code} value={branch.branch_code}>
                {branchOptionLabel(branch)}
              </MenuItem>
            ))}
          </TextField>
        </FilterField>
      )}
      <FilterField label="van">
        <TextField select size="small" fullWidth value={filters.van} onChange={handleVanChange}>
          <MenuItem value={ALL_OPTION}>ทุก van</MenuItem>
          {vanOptions.map((van) => (
            <MenuItem key={van} value={van}>
              {van}
            </MenuItem>
          ))}
        </TextField>
      </FilterField>
      <FilterField label="GROUP">
        <TextField
          select
          size="small"
          fullWidth
          value={filters.shopGroup}
          onChange={handleGroupChange}
        >
          <MenuItem value={ALL_OPTION}>ทุก GROUP</MenuItem>
          {groupOptions.map((group) => (
            <MenuItem key={group} value={group}>
              {group}
            </MenuItem>
          ))}
        </TextField>
      </FilterField>
      <FilterField label="ค้นหา">
        <TextField
          size="small"
          fullWidth
          placeholder="รหัสร้าน หรือ ชื่อร้าน"
          value={filters.search}
          onChange={handleSearchChange}
          slotProps={SEARCH_INPUT_PROPS}
        />
      </FilterField>
    </Grid>
  );
}
